<section class="feedback">
  <h2 class="feedback__title">{{ 'feedback.title' | t }}</h2>
  <button type="button" class="btn-submit feedback__open" data-testid="feedback-open" (click)="open.set(true)">
    {{ 'feedback.open' | t }}
  </button>
</section>

@if (open()) {
  <div class="modal-backdrop">
    <div class="modal-panel" role="dialog" aria-modal="true" aria-labelledby="feedback-title">
      <div class="modal-header">
        <h2 id="feedback-title">{{ 'feedback.title' | t }}</h2>
        <button class="modal-close-btn" type="button" (click)="open.set(false)" [attr.aria-label]="'modalCommon.closeAria' | t">
          &times;
        </button>
      </div>

      <div class="modal-body feedback__body">
        @if (done(); as state) {
          <p class="feedback__done" role="status" data-testid="feedback-done">{{ 'feedback.' + state | t }}</p>
        } @else {
          <fieldset class="feedback__group">
            <legend>{{ 'feedback.outcomeQuestion' | t }}</legend>
            @for (code of outcomes; track code) {
              <label class="feedback__choice">
                <input type="radio" name="feedback-outcome" required [value]="code" [checked]="outcome() === code" (change)="outcome.set(code)" />
                {{ 'feedback.outcomes.' + code | t }}
              </label>
            }
          </fieldset>

          <fieldset class="feedback__group">
            <legend>{{ 'feedback.topicsQuestion' | t }}</legend>
            @for (code of topics; track code) {
              <label class="feedback__choice">
                <input type="checkbox" [checked]="selectedTopics().has(code)" (change)="toggleTopic(code)" />
                {{ 'feedback.topics.' + code | t }}
              </label>
            }
          </fieldset>

          <fieldset class="feedback__group">
            <legend>{{ 'feedback.problemsQuestion' | t }}</legend>
            @for (code of problems; track code) {
              <label class="feedback__choice">
                <input type="checkbox" [checked]="selectedProblems().has(code)" (change)="toggleProblem(code)" />
                {{ 'feedback.problems.' + code | t }}
              </label>
            }
          </fieldset>

          <div class="form-group">
            <label for="feedback-comment">{{ 'feedback.comment' | t }}</label>
            <textarea
              id="feedback-comment"
              rows="4"
              [attr.maxlength]="commentMaxLength"
              [value]="comment()"
              (input)="comment.set($any($event.target).value)"
              aria-describedby="feedback-comment-counter"></textarea>
            <small id="feedback-comment-counter">{{ comment().length }} / {{ commentMaxLength }}</small>
          </div>

          @if (errorMessage()) {
            <p class="feedback__error" role="alert" data-testid="feedback-error">{{ errorMessage() }}</p>
          }
        }
      </div>

      <div class="modal-footer">
        <button type="button" class="btn-cancel" (click)="open.set(false)">{{ 'common.close' | t }}</button>
        @if (!done()) {
          <button type="button" class="btn-submit" data-testid="feedback-submit" [disabled]="!canSubmit()" (click)="submit()">
            {{ 'common.submit' | t }}
          </button>
        }
      </div>
    </div>
  </div>
}
